/**
* Fetches a model or collection from the Backbone store, based on the provided resource type and optional ID.
* later this can be expanded to fetch from other sources or apply additional transformations as needed.
*/
import { getBackboneData, setBackboneData } from './backboneBridge';

export const getStoreResource = (resourceType, id = null, filter = null) => {
    return getBackboneData(resourceType, id, filter);
};

export const setStoreResource = async (resourceType, data) => {
    return await setBackboneData(resourceType, data);
};
